define(() => {
    "use strict";

    return {
        WRONG_ID: {
            id: "wrongId"
        },
        WRONG_BOOKMARKLET: {
            id: "wrongBookmarklet"
        },
        UNKNOWN_IF_ENABLED: {
            id: "unknownIfEnabled"
        },
        ENABLED_HAS_CHANNELS: {
            id: "enabledHasChannels"
        },
        ENABLED_NO_CHANNELS: {
            id: "enabledNoChannels"
        },
        NOT_ENABLED_HAS_CHANNELS: { // preview
            id: "notEnabledHasChannels"
        },
        NOT_ENABLED_NO_CHANNELS: { // preview
            id: "notEnabledNoChannels"
        },
        BROWSER_NOT_SUPPORTED: {
            id: "browserNotSupported"
        },
        PREVIEW_NOT_SUPPORTED: {
            id: "previewNotSupported"
        },
        WINDOW_CLOSED: {
            id: "windowClosed"
        },
        CHECKING: {
            id: "checking"
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/PageStatus.js